"use client";

import Link from "next/link";
import {
  MapPin,
  Lock,
  ShieldCheck,
  Building2,
  Mail,
  Clock,
  Phone,
} from "lucide-react";
import CtaBanner from "./CtaBanner";

const FOOTER_LINKS = {
  Products: [
    { label: "ABSS CRM", href: "/features/crm" },
    { label: "ABSS Books", href: "/features/books" },
    { label: "CRM Pricing", href: "/pricing/crm" },
    { label: "Books Pricing", href: "/pricing/books" },
    { label: "Book a Demo", href: "/contact" },
  ],
  Resources: [
    { label: "Documentation", href: "/documentation" },
    { label: "Quick Start Guide", href: "/documentation/quick-start" },
    { label: "Free Tools", href: "/tools" },
    { label: "GST Calculator", href: "/tools/gst-calculator" },
    { label: "Pipeline Calculator", href: "/tools/sales-pipeline-calculator" },
  ],
  Company: [
    { label: "About ABSS", href: "/about" },
    { label: "Contact Us", href: "/contact" },
    { label: "Partner Program", href: "/contact" },
    { label: "Blog", href: "/blog" },
  ],
};

const CONTACT_INFO = [
  {
    Icon: Mail,
    label: "Email",
    value: "support@abss.ai",
    href: "mailto:support@abss.ai",
  },
  { Icon: Clock, label: "Hours", value: "Mon–Fri, 10 AM–6 PM IST", href: null },
  {
    Icon: Phone,
    label: "WhatsApp",
    value: "+91 74358 09525",
    href: "https://wa.me/917435809525",
    external: true,
  },
];

const SOCIAL_LINKS = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/abss-india",
    icon: (
      <svg
        className="w-4 h-4"
        fill="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    label: "X",
    href: "https://x.com/abssteam",
    icon: (
      <svg
        className="w-4 h-4"
        fill="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/abss.team/",
    icon: (
      <svg
        className="w-4 h-4"
        fill="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
      </svg>
    ),
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61590741750393",
    icon: (
      <svg
        className="w-4 h-4"
        fill="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
];

const COMPLIANCE_ITEMS = [
  {
    Icon: MapPin,
    label: "Made in India",
  },
  {
    Icon: Lock,
    label: "Data stored in India",
  },
  {
    Icon: ShieldCheck,
    label: "GST & E-Invoice compliant",
  },
  {
    Icon: Building2,
    label: "Adaptive Business Support Systems LLP",
  },
];

export default function Footer() {
  return (
    <>
      {/* Combined Final CTA Box - shared component */}
      <CtaBanner withRails />

      <footer className="w-full bg-[#0B0B0B] border-t border-neutral-900 text-white overflow-hidden">
        {/* Main footer grid */}
        <div className="max-w-[1160px] mx-auto px-4 sm:px-6 md:px-10 lg:px-12 py-10 sm:py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 sm:gap-10 lg:gap-8">
            {/* Brand column */}
            <div className="sm:col-span-2 lg:col-span-2">
              <Link href="/">
                <img
                  src="/images/abss-logo-white.png"
                  alt="ABSS"
                  className="h-5 w-auto mb-4 sm:mb-5 opacity-90 hover:opacity-100 transition-opacity"
                />
              </Link>
              <p className="text-[13px] geist-regular text-neutral-300 leading-relaxed mb-5 sm:mb-6 max-w-full sm:max-w-[280px]">
                India&apos;s integrated CRM and accounting platform - built for
                GST compliance, Indian workflows, and SME scale.
              </p>

              {/* Contact info */}
              <div className="space-y-2.5 sm:space-y-3 mb-5 sm:mb-6">
                {CONTACT_INFO.map(({ Icon, label, value, href, external }) => (
                  <div
                    key={label}
                    className="flex flex-wrap items-center gap-x-2.5 gap-y-1 sm:flex-nowrap"
                  >
                    <Icon className="w-3.5 h-3.5 text-[#DF5D01] flex-shrink-0" />
                    <span className="text-[10px] sm:text-[11px] geist-semibold text-neutral-500 w-12 sm:w-14 flex-shrink-0 uppercase tracking-wider">
                      {label}
                    </span>
                    {href ? (
                      <a
                        href={href}
                        {...(external
                          ? { target: "_blank", rel: "noopener noreferrer" }
                          : {})}
                        className="text-[13px] geist-medium text-neutral-200 hover:text-white transition-colors break-all sm:break-normal"
                      >
                        {value}
                      </a>
                    ) : (
                      <span className="text-[12px] sm:text-[13px] geist-medium text-neutral-200">
                        {value}
                      </span>
                    )}
                  </div>
                ))}
              </div>

              {/* Social links */}
              <div className="flex flex-wrap items-center gap-2 sm:gap-2.5">
                {SOCIAL_LINKS.map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.label}
                    className="w-9 h-9 rounded-full bg-neutral-900 border border-neutral-800/80 flex items-center justify-center text-neutral-500 hover:text-white hover:border-neutral-700 transition-colors shadow-sm"
                  >
                    {s.icon}
                  </a>
                ))}
              </div>

              {/* App Download Links */}
              <div className="flex flex-wrap items-center gap-1 mt-6 sm:mt-8">
                <a
                  href="https://play.google.com/store/apps/details?id=com.abss"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-opacity hover:opacity-80 block"
                >
                  <img
                    src="/images/play-store-badge.png"
                    alt="GET IT ON Google Play"
                    className="h-[58px] w-auto -mx-1.5 -my-2"
                  />
                </a>
                <a
                  href="https://apps.apple.com/in/app/abss/id6760467260"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-opacity hover:opacity-80 block"
                >
                  <img
                    src="/images/app-store-badge.svg"
                    alt="Download on the App Store"
                    className="h-[40px] w-auto"
                  />
                </a>
              </div>
            </div>

            {/* Link columns */}
            {Object.entries(FOOTER_LINKS).map(([section, links]) => (
              <div key={section} className="min-w-0">
                <h3 className="text-[11px] geist-bold text-neutral-500 uppercase tracking-widest mb-3 sm:mb-4">
                  {section}
                </h3>
                <ul className="space-y-2.5 sm:space-y-3">
                  {links.map((link) => (
                    <li key={link.label}>
                      <Link
                        href={link.href}
                        className="text-[13px] geist-medium text-neutral-300 hover:text-white transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* India compliance strip */}
        <div className="border-t border-neutral-900/60">
          <div className="max-w-[1160px] mx-auto px-4 sm:px-6 md:px-10 lg:px-12 py-3.5 sm:py-4">
            <div className="flex flex-wrap gap-x-4 sm:gap-x-6 gap-y-2.5">
              {COMPLIANCE_ITEMS.map(({ Icon, label }) => (
                <div key={label} className="flex items-center gap-1.5 min-w-0">
                  <Icon className="w-3.5 h-3.5 text-[#DF5D01]/80 flex-shrink-0" />
                  <span className="text-[10px] sm:text-[11px] geist-medium text-neutral-400 leading-snug">
                    {label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-neutral-900/60">
          <div className="max-w-[1160px] mx-auto px-4 sm:px-6 md:px-10 lg:px-12 py-4 sm:py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-center sm:text-left">
            <p className="text-[11px] sm:text-[12px] geist-regular text-neutral-400 leading-relaxed max-w-full sm:max-w-[60%] lg:max-w-none">
              © {new Date().getFullYear()} ABSS - Adaptive Business Support
              Systems LLP. All rights reserved.
            </p>
            <div className="flex flex-wrap items-center justify-center sm:justify-end gap-x-4 sm:gap-x-5 gap-y-1">
              {[
                { label: "Privacy", href: "/privacy-policy" },
                { label: "Terms", href: "/terms-of-service" },
                { label: "Refund Policy", href: "/refund-policy" },
              ].map((l) => (
                <Link
                  key={l.href}
                  href={l.href}
                  className="text-[12px] geist-medium text-neutral-400 hover:text-white transition-colors"
                >
                  {l.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
